<h4>Widget Control Types</h4>
<p>Choose a widget control type to begin editting</p>

<mat-grid-list cols="3" rowHeight="150px" [gutterSize]="'10px'">
  
  <mat-grid-tile id="textControlTile" class="widgetType-{{widgetTypes[widgetTypes.textControl]}}" [class.selectedItem]="widget.widgetType == widgetTypes.textControl">
    <button id="textControlButton" class="widget-type-button" (click)="widget.widgetType = widgetTypes.textControl">
      <div>
        <div>
          <mat-icon class="mat-icon-widget-type-button">text_fields</mat-icon>
        </div>
        <p style="margin-top:0;">Text Control Widget</p>
      </div>
    </button>
  </mat-grid-tile>

  <mat-grid-tile id="numberControlTile" class="widgetType-{{widgetTypes[widgetTypes.numberControl]}}" [class.selectedItem]="widget.widgetType == widgetTypes.numberControl">
    <button id="numberControlButton" class="widget-type-button" (click)="widget.widgetType = widgetTypes.numberControl">
      <div>
        <div>
          <mat-icon class="mat-icon-widget-type-button">123</mat-icon>
        </div>
        <p style="margin-top:0;">Number Control Widget</p>
      </div>
    </button>
  </mat-grid-tile>

  <mat-grid-tile id="dateTimeControlTile" class="widgetType-{{widgetTypes[widgetTypes.dateTimeControl]}}" [class.selectedItem]="widget.widgetType == widgetTypes.dateTimeControl">
    <button id="dateTimeControlButton" class="widget-type-button" (click)="widget.widgetType = widgetTypes.dateTimeControl">
      <div>
        <div>
          <mat-icon class="mat-icon-widget-type-button">calendar_month</mat-icon>
        </div>
        <p style="margin-top:0;">DateTime Control Widget</p>
      </div>
    </button>
  </mat-grid-tile>


  <mat-grid-tile id="autoCompleteControlTile" class="widgetType-{{widgetTypes[widgetTypes.autoCompleteControl]}}" [class.selectedItem]="widget.widgetType == widgetTypes.autoCompleteControl">
    <button id="autoCompleteControlButton" class="widget-type-button" (click)="widget.widgetType = widgetTypes.autoCompleteControl">
      <div>
        <div>
          <mat-icon class="mat-icon-widget-type-button">search</mat-icon>
        </div>
        <p style="margin-top:0;">AutoComplete Control Widget</p>
      </div>
    </button>
  </mat-grid-tile>

  <mat-grid-tile id="eveUserAutoCompleteControlTile" class="widgetType-{{widgetTypes[widgetTypes.eveUserAutoCompleteControl]}}" [class.selectedItem]="widget.widgetType == widgetTypes.eveUserAutoCompleteControl">
    <button id="eveUserAutoCompleteControlButton" class="widget-type-button" (click)="widget.widgetType = widgetTypes.eveUserAutoCompleteControl">
      <div>
        <div>
          <mat-icon class="mat-icon-widget-type-button">person_search</mat-icon>
        </div>
        <p style="margin-top:0;">Eve User AutoComplete Control Widget</p>
      </div>
    </button>
  </mat-grid-tile>

  <mat-grid-tile id="functionNumberAutoCompleteControlTile" class="widgetType-{{widgetTypes[widgetTypes.functionNumberAutoCompleteControl]}}" [class.selectedItem]="widget.widgetType == widgetTypes.functionNumberAutoCompleteControl">
    <button id="functionNumberAutoCompleteControlButton" class="widget-type-button" (click)="widget.widgetType = widgetTypes.functionNumberAutoCompleteControl">
      <div>
        <div>
          <mat-icon class="mat-icon-widget-type-button">dialpad</mat-icon>
        </div>
        <p style="margin-top:0;">Function Number AutoComplete Control Widget</p>
      </div>
    </button>
  </mat-grid-tile>

</mat-grid-list>

